/**
stats-overview
*/


<!--suppress JSUnfilteredForInLoop -->
<template>
    <div>
        <p class="chart-title">
            Charts showing how different habitats fall within MPAs and byelaws restricting bottom towed fishing gear. Use the
            dropdown to switch between areas of interest.
        </p>

        <div v-if="habitatsData" style="margin-bottom: 10px; font-size: 90%">
            Select area of interest:
            <select v-model="areaSelected">
                <option v-for="area in availableAreas">
                    {{ area }}
                </option>
            </select>
        </div>

        <div id="habitats"></div>

        <area-legend/>
    </div>
</template>


<script>
import store from "../store/reality-check-store";
import AreaLegend from "./chart-union-area-legend.vue";

export default {
    name: "stats-habitats",
    components: {
        AreaLegend
    },
    store,
    props: {
        stateChange: {type: Number, required: true}  // to trigger redraw
    },
    data: function () {
        return {
            areaSelected: "Study area",
            cachedData: {},
            activePlot: undefined
        }
    },
    methods: {
        drawHabitatChart: function () {
            if (!(this.areaSelected in this.cachedData)) {
                this.prepareChartData(this.areaSelected);
            }

            const layout = {
                barmode: "stack", showlegend: false,
                // width: 900,
                autosize: true,
                margin: {
                    t: 60, r: 0, b: 80, l: 100
                },
                // legend: {
                //     "x": 0,
                //     "y": -0.6,
                //     "traceorder": "normal",
                // },
                title: "Broad-scale habitats",
                hovermode: "y",
                xaxis: {
                    title: 'km<sup>2</sup>',
                    ticksuffix: " km<sup>2</sup>",
                    tickformat: ',.0f',
                    showticksuffix: "last"
                },
                yaxis: {
                    autorange: "reversed",
                }
            }

            Plotly.newPlot("habitats", this.cachedData[this.areaSelected], layout, {responsive: true});

            document.getElementById("habitats").on("plotly_hover", function (e) {
                // https://plotly.com/javascript/hover-events/#coupled-hover-events
                var points = e.points[0], pointNum = points.pointNumber;

                Plotly.Fx.hover("habitats", [
                    {curveNumber: 0, pointNumber: pointNum},
                    {curveNumber: 1, pointNumber: pointNum},
                    {curveNumber: 2, pointNumber: pointNum},
                    {curveNumber: 3, pointNumber: pointNum},
                ])
            })
        },
        prepareChartData: function (area) {
            const data = this.habitatsData[area]
            var x1 = [], y1 = [], x2 = [], y2 = [], x3 = [], y3 = [], x4 = [], y4 = []
            // todo: y1-4 can be just 1 variable, doesn't change!
            for (const hab in data["area in mpa and byelaw"]) {
                x1.push(data["area in mpa and byelaw"][hab])
                y1.push(hab.charAt(0).toUpperCase() + hab.slice(1).replace("/o", "/<br>o"))
            }
            for (const hab in data["area in mpa and not in byelaw"]) {
                x2.push(data["area in mpa and not in byelaw"][hab])
                y2.push(hab.charAt(0).toUpperCase() + hab.slice(1).replace("/o", "/<br>o"))
            }
            for (const hab in data["area not in mpa and in byelaw"]) {
                x3.push(data["area not in mpa and in byelaw"][hab])
                y3.push(hab.charAt(0).toUpperCase() + hab.slice(1).replace("/o", "/<br>o"))
            }
            for (const hab in data["area not in mpa and not in byelaw"]) {
                x4.push(data["area not in mpa and not in byelaw"][hab])
                y4.push(hab.charAt(0).toUpperCase() + hab.slice(1).replace("/o", "/<br>o"))
            }

            this.cachedData[area] = [
                {
                    "type": "bar",
                    "name": "Area in an MPA and protected by a byelaw restricting bottom towed fishing gear",
                    "x": x1,
                    "y": y1,
                    "orientation": "h",
                    "hoverinfo": "x",
                    "marker": {
                        "color": "rgba(124, 184, 84, 1)"
                    }
                },
                {
                    "type": "bar",
                    "name": "Area in an MPA but not protected by a byelaw restricting bottom towed fishing gear",
                    "x": x2,
                    "y": y2,
                    "orientation": "h",
                    "hoverinfo": "x",
                    "marker": {
                        "color": "rgba(242, 183, 1, 1)"
                    }
                },
                {
                    "type": "bar",
                    "name": "Area not in an MPA but protected by a byelaw restricting bottom towed fishing gear",
                    "x": x3,
                    "y": y3,
                    "orientation": "h",
                    "hoverinfo": "x",
                    "marker": {
                        "color": "rgba(48, 93, 158, 1)"
                    }
                },
                {
                    "type": "bar",
                    "name": "Area not in an MPA or a byelaw restricting bottom towed fishing gear",
                    "x": x4,
                    "y": y4,
                    "orientation": "h",
                    "hoverinfo": "x",
                    "marker": {
                        "color": "rgba(194, 195, 196, 1)"
                    }
                },
            ];
        }
    },
    computed: {
        habitatsData: function () {
            return this.$store.state.stats.habitatsData
        },
        availableAreas: function () {
            if (!this.habitatsData) {
                return []
            }
            return Object.keys(this.habitatsData)
        }
    },
    watch: {
        habitatsData: function () {
            if (this.habitatsData) {
                this.drawHabitatChart()
            }
        },
        areaSelected: function () {
            this.drawHabitatChart()
        },
        stateChange: function () {
            this.drawHabitatChart();
        }
    },
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";
</style>